'use client';

import { useEffect } from 'react';
import AOS from 'aos';

import 'aos/dist/aos.css';

export function useAOS() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Durée des animations (en ms)
      anchorPlacement: 'bottom-bottom',
    });
  }, []);
}
